// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Ui0PDdZ4tUttlijymzrr {\n  justify-content: center;\n}\n.Ui0PDdZ4tUttlijymzrr a {\n  display: flex;\n}\n", "",{"version":3,"sources":["webpack://./src/components/strategyProject/tabs/TabResults/TableAction/style.module.less"],"names":[],"mappings":"AAAA;EACE,uBAAA;AACF;AAFA;EAGI,aAAA;AAEJ","sourcesContent":[".dropdown{\n  justify-content: center;\n  a{\n    display: flex;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown": "Ui0PDdZ4tUttlijymzrr"
};
export default ___CSS_LOADER_EXPORT___;
